<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Automação - Enviar Email</v-toolbar-title>
      </v-toolbar>
      <v-row class="px-4">
        <v-col md="6">
          <p class="font-weight-bold">Dados para envio</p>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nome da turma (igual a como está no suporte)"
                v-model="celebrationName"
                placeholder="Medicina Nassau 10"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Assunto"
                v-model="subject"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Mensagem"
                v-model="message"
                outlined dense
                rows="6"
              ></v-textarea>
            </v-col>
          </v-row>
          <p class="font-weight-bold pt-6">Participantes</p>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Usuários separado por ponto-e-virgula: email|nome; email2|nome2"
                v-model="destinations"
                outlined dense
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6">
          <div class="pa-4 rounded-borders blue-grey lighten-5">
            <div>Assunto: <b>{{ celebrationName }} - {{ subject }}</b></div>
            <div
              style="white-space: pre-line"
              v-html="message"
            />
          </div>

          <div class="row items-center mt-4">
            <div class="col title">Usuários</div>
            <div class="col-auto">
              <v-btn color="success" :disabled="sending" :loading="sending" @click="sendMessages()">
                Enviar
              </v-btn>
            </div>
          </div>
          <v-data-table
            dense
            :headers="headers"
            :items="items"
            :disable-pagination="true"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      sending: false,
      celebrationName: '',
      subject: '',
      message: `Olá, [item2]!

Aqui você coloca a mensagem que quiser.
      `,
      destinations: '',
      items: [],
      headers: [
        {
          text: 'Nome',
          value: 'name',
          sortable: false
        },
        {
          text: 'E-mail',
          value: 'email',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false
        }
      ]
    }
  },
  computed: {
    //
  },
  watch: {
    destinations () {
      this.generateItems()
    }
  },
  methods: {
    ...mapActions(['sendEmail']),
    generateItems () {
      if (this.destinations) {
        this.items = []
        const destArray = this.destinations.split(';')
        for (let i = 0; i < destArray.length; i++) {
          if (destArray[i].trim()) {
            const itemData = destArray[i].split('|')
            const item = {
              email: itemData[0].trim(),
              name: (itemData[1]) ? itemData[1].trim() : '',
              status: 'Aguardando'
            }
            for (const j in itemData) {
              item['item' + (parseInt(j) + 1)] = itemData[j]
            }
            this.items.push(item)
          }
        }
      }
    },
    async sendMessages () {
      if (this.destinations && this.items && this.subject && this.celebrationName && this.message) {
        this.sending = true
        for (let i = 0; i < this.items.length; i++) {
          const index = i
          const item = this.items[i]
          let messageToSend = this.message

          for (const key in item) {
            messageToSend = messageToSend.replace('[' + key + ']', item[key])
          }

          const data = {
            'email': item.email,
            'name': item.name,
            'subject': this.celebrationName + ' - ' + this.subject,
            'content': messageToSend.replaceAll('\n', '<br />')
          }

          await this.sendEmail(data)
            .then(() => { this.items[index].status = 'ok' })
            .catch(() => { this.items[index].status = 'fail' })

          this.sending = false
        }
      }
    }
  },
  mounted () {
    //
  }
}
</script>
